import { render, staticRenderFns } from "./SatisfactionMetrics.vue?vue&type=template&id=49f24086&scoped=true"
import script from "./SatisfactionMetrics.vue?vue&type=script&lang=js"
export * from "./SatisfactionMetrics.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionMetrics.vue?vue&type=style&index=0&id=49f24086&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f24086",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f24086')) {
      api.createRecord('49f24086', component.options)
    } else {
      api.reload('49f24086', component.options)
    }
    module.hot.accept("./SatisfactionMetrics.vue?vue&type=template&id=49f24086&scoped=true", function () {
      api.rerender('49f24086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/SatisfactionMetrics.vue"
export default component.exports